<template>
    <div>
      <div class="d-flex justify-content-between">
        <h1 class="page-header">{{ $t('quotation.pageTitle') }}</h1>
        <ts-breadcrumb
          :items="[
            { text: $t('toHomePage'), href: '/' },
            {
              text: $t('quotation.pageTitle'),
              href: '/pre-invoices'
            },
            {
              text: $t('show'),
              active: true
            }
          ]"
        />
      </div>
      <ts-card>
        <ts-card-wrapper>
          <div class="row form-group">
            <div class="col-md-6">
              <form class="form-horizontal">
                <fieldset>
                  <legend>{{ $t('quotation.inquiryInfo') }}</legend>
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('quotation.studentName')
                    }}</label>
                    <div class="col-md-9">
                      <input
                        readonly
                        class="form-control-plaintext ts-text-sm"
                        :value="showData.inquiry.full_name_en"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('quotation.sex')
                    }}</label>
                    <div class="col-md-9">
                      <input
                        readonly
                        class="form-control-plaintext ts-text-sm"
                        :value="showData.inquiry.gender"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('quotation.phone')
                    }}</label>
                    <div class="col-md-9">
                      <input
                        readonly
                        class="form-control-plaintext ts-text-sm"
                        :value="showData.inquiry.contact_number"
                      />
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
            <div class="col-md-6">
              <form class="form-horizontal">
                <fieldset>
                  <legend>{{ $t('quotation.academic') }}</legend>
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('quotation.mainProgram')
                    }}</label>
                    <div class="col-md-9">
                      <input
                        readonly
                        class="form-control-plaintext ts-text-sm"
                        :value="showData.main_program.acp_name_foreign"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('quotation.academicTermName')
                    }}</label>
                    <div class="col-md-9">
                      <input
                        readonly
                        class="form-control-plaintext ts-text-sm"
                        :value="showData.academic_term.term_name"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('quotation.gradeName')
                    }}</label>
                    <div class="col-md-9">
                      <input
                        readonly
                        class="form-control-plaintext ts-text-sm"
                        :value="showData.grade.grade_name_foreign"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-3 col-form-label">{{
                      $t('quotation.studyTime')
                    }}</label>
                    <div class="col-md-9">
                      <input
                        readonly
                        class="form-control-plaintext ts-text-sm"
                        :value="showData.study_time"
                      />
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-12">
              <panel :title="$t('quotation.itemList')">
                <div class="overflow-auto">
                  <div id="list-container">
                    <table
                      class="table ui-table ts-table"
                    >
                      <thead>
                        <tr>
                          <th
														class="ts-whitespace-no-wrap ts-uppercase"
														style="width:300px"
													>
														{{ $t('quotation.feeType') }}
													</th>
													<th
														class="ts-whitespace-no-wrap ts-uppercase"
														style="width:300px"
													>
														{{ $t('quotation.feeName') }}
													</th>
													<th
														class="ts-whitespace-no-wrap ts-uppercase"
														style="width: 290px;"
													>
														{{ $t('quotation.description') }}
													</th>
													<th
														class="ts-whitespace-no-wrap ts-uppercase ts-text-center"
														style="width: 90px;"
													>
														{{ $t('quotation.qty') }}
													</th>
													<th
														class="ts-whitespace-no-wrap ts-uppercase ts-text-center"
														style="width: 119px;"
													>
														{{ $t('quotation.fee') }}
													</th>
													<th
														class="ts-whitespace-no-wrap ts-uppercase ts-text-center"
														style="width: 113px;"
													>
														{{ $t('quotation.discountType') }}
													</th>
													<th
														class="ts-whitespace-no-wrap ts-uppercase ts-text-center"
														style="width: 114px;"
													>
														{{ $t('quotation.discount') }}
													</th>
													<th
														class="ts-whitespace-no-wrap ts-uppercase ts-text-center"
														style="width: 101px;"
													>
														{{ $t('quotation.vat') }}(%)
													</th>
													<th
														class="ts-whitespace-no-wrap ts-uppercase ts-text-center"
														style="width: 100px;"
													>
														{{ $t('quotation.amount') }}
													</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in showData.quotation_detail"
                          :key="index"
                        >
                          <td>{{ item.fee_type.fee_type_name }}</td>
                          <td>{{ item.fee_setup.fee_name_en }}</td>
                          <td>{{ item.fee_description }}</td>
                          <td class="text-center">{{ item.quantity }}</td>
                          <td class="text-center">{{ item.fee_amount }}</td>
                          <td class="text-center">{{ item.discount_type }}</td>
                          <td class="text-center">{{ item.discount_rate }}</td>
                          <td class="text-center">{{ item.vat_rate }}</td>
                          <td class="text-right">{{ item.total_amount }}</td>
                        </tr>
                        <tr>
                          <td colspan="8" class="text-right">
                            <strong>{{ $t('quotation.total') }}</strong>
                          </td>
                          <td class="text-right">
                            <strong
                              ><u>{{ showData.fee_amount }}</u></strong
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </panel>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 text-right">
              <ts-button @click="$router.push({ name: 'quotation' })">{{
                $t('close')
              }}</ts-button>
            </div>
          </div>
        </ts-card-wrapper>
      </ts-card>
    </div>
  </template>
  
  <script>
  import { mapState } from 'vuex'
  export default {
    name: 'quotationShow',
    data() {
      return {}
    },
    created() {},
    computed: {
      ...mapState('quotation', ['showData'])
    }
  }
  </script>
  
  <style lang="css" scoped>
  #list-container {
    white-space: nowrap;
  }
  .table > thead > tr > th {
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    z-index: 999;
  }
  .table > tbody > tr > td {
    padding-top: 5px !important;
    padding-bottom: 5px !important;
    border: none !important;
  }
  </style>
  